<section class="container">
  <h6>Arquivos</h6>
  <div class="alert alert-info container" *ngIf="!arquivo || !arquivo.length; else listaArquivos">
    Não foram encontrados arquivos para os filtros selecionados
  </div>
  <ng-template #listaArquivos>
    <bn-paginacao [total]="countArquivo" [tamanhoPagina]="atributosPaginacao.pageSize"
    [numPagina]="atributosPaginacao.page" [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col">CNPJ Agente Financeiro</th>
              <th scope="col">Usuário</th>
              <th scope="col">Tipo da Solicitação</th>
              <th scope="col">Data da Solicitação</th>
              <th scope="col">Download Arquivo</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaArquivo">
              <td>{{item.agenteFinanceiro.cnpj | bnMask: 'CNPJ'}}</td>
              <td>{{item.usuario}}</td>
              <td>{{labelSolicitacaoArquivo(item.codigoTipoSolicitacaoArquivo)}}</td>
              <td>{{item.dataSolicitacao | date: 'dd-MM-yyyy HH:mm:ss'}}</td>
              <td class="text-start">
                  <a href="javascript:void(0)" (click)="buscaConteudo(item.id)">
                    <span class="font-monospace fw-bold">CSV&ensp;</span>
                    <i class="fa fa-download">
                    </i>
                  </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </ng-template>
</section>
